import { listOfValuesApi as API } from '../Apis';
import {
  ListOfValuesApiRequest,
  ListOfValuesApiResponse,
} from '../Apis/ListOfValuesApi';
import { IMockProps, Mocks, MockServiceType } from '../Core';
import { ListType, ValueItem } from '../Types/ListOfValues.types';

const allTypes: ListType[] = [
  'flight_special_service',
  'AAG_ACCOUNT_TYPE',
  'DOCUMENT',
  'LANGUAGE',
  'CITIZENSHIP',
  'CITIZENSHIP_PASSENGER',
  'SEX',
  'COUNTRY',
  'STATE',
  'GIFT_EVENT',
  'DEFAULT_MEMBERSHIP_PLAN',
  'GOL_PARTNER',
  'GOL_MOTIVOS_RECUSA_CLUB',
  'LOY_TXN_TYPE_CD',
  'GOL_PARCEIRO_TIPO',
];

const generateItemListFromType = (type: ListType, size = 10): ValueItem[] =>
  Array.from(Array(size)).map((_, idx) => ({
    name: `Item ${idx}`,
    value: `${type}-${idx}`,
    description: idx % 2 === 0 ? `${type} item description` : undefined,
  }));

const generateRequestData = (
  partial: Partial<ListOfValuesApiRequest> = {},
): ListOfValuesApiRequest => {
  return {
    language: 'pt_br',
    type: 'AAG_ACCOUNT_TYPE',
    ...partial,
  };
};

const generateResponseData = (items: ValueItem[]): ListOfValuesApiResponse => {
  return {
    valueByTypeList: items,
    metaInformation: {
      orderField: [
        {
          field: 'name',
          order: 'ASC',
        },
      ],
      pagination: {
        page: 1,
        quantity: items.length,
        total: items.length,
      },
    },
  };
};

const generateMockProps = (
  statusCode: number,
  request: ListOfValuesApiRequest,
  response: ListOfValuesApiResponse,
): IMockProps => {
  return {
    configRequest: {
      method: 'GET',
      path: API.definitions.ENDPOINT_API_PATH,
      params: request,
    },
    configResponse: {
      status: statusCode,
      data: response,
    },
  };
};

const generatedSuccessMocks = allTypes.map((it) =>
  generateMockProps(
    200,
    generateRequestData({ type: it }),
    generateResponseData(generateItemListFromType(it)),
  ),
);

const generatedErrorMocks = allTypes.map((it) =>
  generateMockProps(
    500,
    generateRequestData({ type: it, language: 'es_es' }),
    generateResponseData(generateItemListFromType(it)),
  ),
);

export const mocksService: MockServiceType<ListOfValuesApiRequest>[] =
  generatedSuccessMocks.map((request) => ({
    label: `[Sucesso] - ${JSON.stringify(request.configRequest.params)}`,
    value: request.configRequest.params,
  }));

Mocks.getInstance().addAll(generatedSuccessMocks);
Mocks.getInstance().addAll(generatedErrorMocks);
